import {IRecursoFiltroDto} from "@models/recurso/dto.ts";
import {Button, FormControlLabel, Grid, Switch, TextField} from "@mui/material";
import {MoneyInputEntry} from "@components/shared/FormEntries/InputEntry.tsx";
import React, {useState} from "react";
import {fullHeight} from "@models/helpers.ts";
import {CheckOutlined} from "@mui/icons-material";
import {DefaultFilterPageProps} from "@models/DefaultFilterPageProps.ts";

interface RecursoFiltersPageProps extends DefaultFilterPageProps<IRecursoFiltroDto> {
}

export function RecursoFiltersPage(props: RecursoFiltersPageProps) {
    const {filters, setFilters, onApply} = props;

    const [value, setValue] = useState({...filters});

    const handleAplicar = () => {
        if (setFilters) setFilters(value);
        if (onApply) onApply();
    }

    const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key == 'Enter') {
            handleAplicar()
        }
    }

    return (<Grid container>
        <Grid container size={12} mb={1} justifyContent={'space-between'}>
            <Grid/>
            <Grid>
                <Button fullWidth
                        onClick={handleAplicar}
                        disabled={JSON.stringify(value) == JSON.stringify(filters)}
                        color={'success'}
                        sx={{...fullHeight}}
                        endIcon={<CheckOutlined/>}>Aplicar</Button>
            </Grid>
        </Grid>
        <Grid size={{
            sm: 12,
            md: 3,
            lg: 3,
            xl: 3,
        }}>
            <TextField label={'Nome'}
                       onKeyDown={handleEnter}
                       value={value.nome ?? ''} onChange={(e) => setValue({...value, nome: e.target.value})}/>
        </Grid>
        <Grid size={{
            sm: 12,
            md: 9,
            lg: 9,
            xl: 9,
        }}>
            <TextField value={value.descricao ?? ''} label={'Descricao'}
                       onKeyDown={handleEnter}
                       onChange={(e) => setValue({...value, descricao: e.target.value})}/>
        </Grid>
        <Grid size={{
            sm: 12,
            md: 6,
            lg: 6,
            xl: 6,
        }}>
            <MoneyInputEntry value={value.valorInicial}
                             label={'Valor Minimo'}
                             onEnter={handleAplicar}
                             onChange={(e) => setValue({...value, valorInicial: e})}/>
        </Grid>
        <Grid size={{
            sm: 12,
            md: 6,
            lg: 6,
            xl: 6,
        }}>
            <MoneyInputEntry value={value.valorFinal}
                             onEnter={handleAplicar}
                             label={'Valor Maximo'}
                             onChange={(e) => setValue({...value, valorFinal: e})}/>
        </Grid>
        <Grid container>
            <FormControlLabel control={<Switch onChange={x => setValue({...value, ativo: x.target.checked})}/>}
                              label={'Ativo'} value={value.ativo}/>
        </Grid>
    </Grid>)
}